module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "objectdata-view container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8 main"
  }, _vm._l((_vm.objectdataTextItems), function(item) {
    return _c('div', {
      staticClass: "row"
    }, [_c('erco-text-input', {
      staticClass: "col-12",
      attrs: {
        "data-infotextkey": ("objectdata." + (item.labelKey)),
        "label": item.label,
        "text": item.value,
        "inputType": "input",
        "keepUnfocused": true,
        "forcePointerCursor": true,
        "forceFocusOutline": _vm.isSidebarFocused(item.labelKey),
        "error": item.mandatory === 'true' && item.value === '',
        "tooltip": _vm.tooltipFor(item),
        "charlength": item.charlength,
        "showMandatory": item.mandatory === 'true'
      },
      on: {
        "click": function($event) {
          _vm.openSidebarFor(item)
        }
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "col-4 aside"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11b97d0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/ErcoObjectView/ObjectData.vue
// module id = 593
// module chunks = 0